module.exports = __webpack_public_path__ + "static/media/achievement-snack-attack.c26d79cd.svg";